import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import SCHCTemplate from 'shared/models/SCHCTemplate';
import { generateRandomString } from 'utils/string';

import SCHCTemplatesDetailsAccordionLayout from './SCHCTemplatesDetailsAccordionLayout';

type SCHCTemplatesDetailsRenderCompressionProps = {
  data: SCHCTemplate.API.Compression.RuleT | undefined;
}
function SCHCTemplatesDetailsRenderCompression({
  data,
}: SCHCTemplatesDetailsRenderCompressionProps) {
  if (!data) {
    return null;
  }

  type ruleEntriesByProtocolT = {
    protocol: string;
    ruleEntries: Array<SCHCTemplate.API.Compression.Flow.RuleEntriesT>,
  }
  // getListRuleEntriesByProtocol returns an
  // array of type ruleEntriesByProtocolT
  // that contains all the rule entries
  // sorted by protocol.
  const getListRuleEntriesByProtocol = ():
  Array<ruleEntriesByProtocolT> => {
    const { ruleEntries } = data.flows[0];
    const formatedData: Record<
      string,
      Array<SCHCTemplate.API.Compression.Flow.RuleEntriesT>
    > = {};
    /* Order by protocol and store in object */
    ruleEntries.forEach((ruleEntry) => {
      try {
        const protocol = ruleEntry.displayName.split(' ')[0];
        if (!(protocol in formatedData)) {
          formatedData[protocol] = [];
        }
        formatedData[protocol] = [...formatedData[protocol], ruleEntry];
      } catch (error) {
        console.error('Error displayName not invalid in ruleEntry');
      }
    });
    /* Turn the object in array object { protocol, ruleEntries } */
    const outputArray: Array<ruleEntriesByProtocolT> = [];
    Object.keys(formatedData)
      .forEach((protocol) => outputArray.push(
        {
          protocol,
          ruleEntries: formatedData[protocol],
        },
      ));
    return outputArray;
  };

  return (
    <SCHCTemplatesDetailsAccordionLayout title={`Rule #${data.ruleId} · Compression · ${data.stack.displayName}`}>
      {
        getListRuleEntriesByProtocol().map((item) => (
          <div
            className="schc-templates-render__item--compression"
            key={generateRandomString()}
          >
            <h2>{ item.protocol } Layer</h2>
            <TableContainer component={Paper}>
              <Table aria-label="table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Value</TableCell>
                    <TableCell align="center">Size (bits)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    item.ruleEntries.map((ruleEntry) => (
                      <TableRow key={generateRandomString()}>
                        <TableCell align="center">{ruleEntry.displayName.replace(item.protocol, '')}</TableCell>
                        <TableCell align="center">{[ruleEntry.targetValue]}</TableCell>
                        <TableCell align="center">{ruleEntry.fieldLength}</TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ))
      }
    </SCHCTemplatesDetailsAccordionLayout>
  );
}

export default SCHCTemplatesDetailsRenderCompression;
